//import external libraries
import React, { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";

//import internal resources and services
import { setSnackbar } from "../../../actions/snackbarActions";
import { ReactComponent as MollierChartIcon } from "../../../image/MollierChartIconSmall.svg";
import ProjectItemCardHydra from "./ProjectItemCardHydra";
import {
  deleteHydraProjectItem,
  getProjectItemHydraSingle,
} from "../../../utils/services/projectService";

//import MUI components
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import ArticleIcon from "@mui/icons-material/Article";
import ViewListIcon from "@mui/icons-material/ViewList";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import MoveUpIcon from "@mui/icons-material/MoveUp";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import ThreeDRotationIcon from "@mui/icons-material/ThreeDRotation";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import { useTheme } from "@mui/material/styles";
import {
  DataGrid,
  GridToolbar,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarExport,
  GridToolbarDensitySelector,
} from "@mui/x-data-grid";
import Stack from "@mui/material/Stack";

const ProjectItemRevisionHydra = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const [button3D, setButton3D] = useState(false);
  const { t } = useTranslation();
  const [documentationExist, setDocumentationExist] = useState(false);
  const [activePosition, setActivePosition] = useState({});
  const [ThreeDLink, set3DLink] = useState("");
  const [columnsToShow, setColumns] = useState([]);
  const [projects, setProject] = useState([]);
  const [selectionModel, setSelectionModel] = useState([]);
  const [rows, setRows] = React.useState([]);
  const [openDialogDelete, setOpenDialogDelete] = React.useState(false);
  const handleCloseDialogDelete = () => {
    setOpenDialogDelete(false);
  };
  const handleOpenDialogDelete = () => {
    setOpenDialogDelete(true);
  };
  const dispatch = useDispatch();
  function deleteProjectItem() {
    deleteHydraProjectItem(activePosition.id)
      .then((res) => {
        setOpenDialogDelete(false);
        dispatch(
          setSnackbar(
            true,
            "success",
            t("snackbar.deleteProjectSuccess"),
            "/project-item"
          )
        );
      })
      .catch((err) => console.log(err));
  }

  useEffect(() => {
    if (location.state !== null) {
      getProjectItemHydraSingle(location.state.id).then((res) => {
        setActivePosition(res.data);
      });
    }
  }, []);

  useEffect(() => {
    let initialColums = [];
    for (const group of columnGroupingModel) {
      initialColums.push(...group.children);
    }
    setColumns(initialColums);
    // setProjectItemId(location.state.id);
    // setInitialColumnsUpdated(true);
  }, []);

  const columnGroupingModel = [
    {
      groupId: "mainData",
      children: [
        // {
        //   field: "id",
        //   headerName: "ID",
        //   minWidth: 60,
        //   align: "center",
        //   headerAlign: "center",
        //   headerClassName: "header-style",
        // },
        {
          field: "name",
          headerName: t("projectitem.fieldName"),
          minWidth: 210,
          headerAlign: "center",
          align: "center",
          headerClassName: "header-style",
        },
        {
          field: "poolName",
          headerName: t("hydraPro.poolName"),
          minWidth: 140,
          headerAlign: "center",
          align: "center",
          headerClassName: "header-style",
        },

        // {
        //   field: "createdAt",
        //   headerName: t("projectitemrevision.createdAt"),
        //   width: 160,
        //   // headerClassName: "header-style",
        //   valueGetter: (params) => {
        //     const localTime = new Date(
        //       new Date(params.row.createdAt).getTime() -
        //         params.row.timeZone * 60000
        //     );

        //     return moment(localTime).format("DD/MM/YYYY HH:mm:ss");
        //   },
        // },
        {
          field: "typeOfPool",
          headerName: t("hydraPro.poolTypeTable"),
          type: "number",
          minWidth: 120,
          align: "center",
          headerClassName: "header-style",
          headerAlign: "center",
        },
        {
          field: "poolVolume",
          headerName: t("hydraPro.poolVolume"),
          type: "number",
          minWidth: 250,
          align: "center",
          headerClassName: "header-style",
          headerAlign: "center",
        },
        {
          field: "waterSurface",
          headerName: t("hydraPro.waterSurface"),
          minWidth: 260,
          headerClassName: "header-style",
          align: "center",
          headerAlign: "center",
        },
      ],
    },
    {
      groupId: "thermodynamicParams",
      children: [
        {
          field: "airTemperature",
          headerName: t("hydraPro.airTemp"),
          minWidth: 280,
          headerClassName: "header-style",
          align: "center",
          headerAlign: "center",
          //   valueFormatter: ({ value }) => t(`unitTypeList.${value}`),
        },
        {
          field: "waterTemperature",
          headerName: t("hydraPro.waterTemp"),
          minWidth: 260,
          headerClassName: "header-style",
          align: "center",
          headerAlign: "center",
        },
        {
          field: "airHumidity",
          headerName: t("hydraPro.airHumid"),
          minWidth: 290,
          //   renderCell: RenderButtonDelete,
          align: "center",
          headerAlign: "center",
          sortable: false,
          disableColumnMenu: true,
          headerClassName: "header-style",
        },
      ],
    },
    {
      groupId: "maxAir",
      children: [
        {
          field: "maxRrequiredAir",
          //   valueFormatter: sizeOfUnitValueFormatter,
          headerName: t("hydraPro.maximumRequiredAmountAir"),
          minWidth: 300,
          headerClassName: "header-style",
          align: "center",
          headerAlign: "center",
        },
        {
          field: "minRequiredFreshAir",
          headerName: t("hydraPro.minimumRequiredAmountFreshAir"),
          minWidth: 340,
          headerClassName: "header-style",
          align: "center",
          headerAlign: "center",
          //   valueFormatter: ({ value }) => t(`unitTypeList.${value}`),
        },
        {
          field: "numOfAirChanges",
          headerName: t("hydraPro.numberAirChangesPoolArea"),
          minWidth: 330,
          //   renderCell: RenderButtonEdit,
          align: "center",
          headerAlign: "center",
          sortable: false,
          disableColumnMenu: true,
          headerClassName: "header-style",
        },
      ],
    },
    {
      groupId: "ahuSelectionSize",
      children: [
        {
          field: "unitType",
          headerName: t("projectitemrevision.unitType"),
          align: "center",
          headerAlign: "center",
          headerClassName: "header-style",
          width: 255,
          editable: false,
          sortable: false,
          valueFormatter: ({ value }) => t(`unitTypeList.${value}`),
        },
        {
          field: "sizeOfUnit",
          headerName: t("projectitemrevision.sizeOfUnit"),
          // valueFormatter: sizeOfUnitValueFormatter,
          align: "center",
          headerAlign: "center",
          type: "text",
          headerClassName: "header-style",
          width: 160,
          editable: false,
          sortable: false,
        },
        {
          field: "numOfUnits",
          headerName: t("hydraPro.numberOfUnits"),
          minWidth: 170,
          //   renderCell: RenderButtonDelete,
          align: "center",
          headerAlign: "center",
          sortable: false,
          disableColumnMenu: true,
          headerClassName: "header-style",
        },
        {
          field: "price",
          headerName: t("projectitem.price"),
          minWidth: 100,
          headerAlign: "center",
          align: "center",
          type: "number",
          valueFormatter: ({ value }) => `${value.toFixed(2)} €`,
          headerClassName: "header-style",
        },
      ],
    },
  ];

  return (
    <>
      <Container component="main" maxWidth sx={{ minHeight: "63vh" }}>
        <Box sx={{ height: "40%", mt: 1 }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <ArticleIcon sx={{ width: 50, height: 50 }} />
              <Typography component="h1" variant="h5" sx={{ margin: 2 }}>
                {/* {t("projectitemrevision.activeposition")}: {activePosition.name} */}
                {t("projectitemrevision.activeposition")}: {activePosition.name}
              </Typography>
              <Box>
                {button3D && (
                  <Button>
                    {" "}
                    <ThreeDRotationIcon
                      onClick={() => {
                        window.open(ThreeDLink);
                      }}
                      sx={{ color: theme.palette.primary.main }}
                    />
                  </Button>
                )}
                {documentationExist && (
                  <Button
                    onClick={() => {
                      navigate("/mollier_chart", {
                        //   state: activePosition,
                      });
                    }}
                  >
                    {" "}
                    <MollierChartIcon />
                  </Button>
                )}

                {/* {documentationExist && (
                <Button>
                  <TechCardLinkProlux
                    heatRecovery={activePosition.heatRecovery}
                    id={activePosition.id}
                    revNum={activePosition.revisionNumber}
                    //docName={docName}
                  />
                </Button>
              )} */}
              </Box>
            </Box>
            <Box sx={{ flex: "1", textAlign: "right", paddingRight: "35px" }}>
              {/* <Button onClick={() => editProjectItem()}> */}
              <Button
                onClick={() => {
                  navigate("/hydra", { state: activePosition });
                }}
              >
                <EditIcon sx={{ color: theme.palette.primary.main }} />
              </Button>

              <Button onClick={handleOpenDialogDelete}>
                {" "}
                <DeleteIcon sx={{ color: theme.palette.primary.main }} />
              </Button>
            </Box>
          </Box>

          <Dialog
            disableScrollLock={true}
            open={openDialogDelete}
            onClose={handleCloseDialogDelete}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            PaperProps={{ sx: { padding: "10px 20px" } }}
            sx={{ backdropFilter: "blur(5px)" }}
          >
            <DialogTitle id="alert-dialog-title" sx={{ fontSize: "30px" }}>
              {t("projectitem.dialogTitle")}
            </DialogTitle>
            <DialogContent>
              <DialogContentText
                id="alert-dialog-description"
                sx={{ fontSize: "20px", color: "#222" }}
              >
                {t("projectitem.dialogContentText")}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={handleCloseDialogDelete}
                variant="outlined"
                sx={{
                  fontSize: "18px",
                  marginRight: "5px",
                  padding: "2px",
                  "&:hover": {
                    backgroundColor: "rgba(0, 0, 0, 0.9)",
                    color: theme.palette.secondary.main,
                  },
                }}
              >
                {t("projectitem.buttonNo")}
              </Button>
              <Button
                onClick={() => deleteProjectItem()}
                autoFocus
                variant="outlined"
                sx={{
                  fontSize: "18px",
                  padding: "2px",
                  "&:hover": {
                    backgroundColor: "rgba(0, 0, 0, 0.9)",
                    color: theme.palette.secondary.main,
                  },
                }}
              >
                {t("projectitem.buttonYes")}
              </Button>
            </DialogActions>
          </Dialog>

          <Divider />
        </Box>
        <Box
          sx={{
            height: "500px",
            display: "flex",
            alignItems: "center",
            paddingX: "10%",
            justifyContent: "center",
          }}
        >
          <ProjectItemCardHydra
            activePosition={activePosition}
          ></ProjectItemCardHydra>
        </Box>
      </Container>

      {/* <Box sx={{ height: "40%", mt: 1 }}>
        <Box
          sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}
        >
          <ViewListIcon sx={{ width: 50, height: 50 }} />
          <Typography component="h1" variant="h5" sx={{ margin: 2 }}>
            {t("projectitemrevision.tabname")}
          </Typography>
        </Box>
        <Divider sx={{ mb: 3 }} />
      </Box>  */}

      {/* <Grid container direction="row" pb={2}>
        <Button disabled>
          {t("projectitemrevision.group")}: {"tabName"}{" "}
        </Button>

        <Button variant="outlined">{t("projectitemrevision.showAll")}</Button>
      </Grid> */}

      {/* <div style={{ height: "500px", mb: "50px", width: "100%" }}>
        <DataGrid
          rows={projects}
          sx={{
            'div[data-rowIndex][role="row"]:first-of-type)': {
              backgroundColor: "rgb(128, 202, 239)",
            },
            'div[data-rowIndex][role="row"]:first-of-type button': {
              display: "none",
            },
            ".MuiDataGrid-columnHeaders": {
              backgroundColor: theme.palette.secondary.main,
            },
            ".MuiTablePagination-select": {
              "margin-top": "-3px",
            },
            ".MuiTablePagination-selectIcon": {
              "margin-top": "-3px",
            },
            ".MuiDataGrid-columnHeaderTitle.css-1jbbcbn-MuiDataGrid-columnHeaderTitle":
              {
                fontWeight: "bold",
                paddingLeft: "5px",
              },
          }}
          columns={columnsToShow}
          rowsPerPageOptions={[10, 20, 100]}
          onSelectionModelChange={(newSelectionModel) => {
            setSelectionModel(newSelectionModel);
          }}
          selectionModel={selectionModel}
          {...rows}
          components={{
            NoRowsOverlay: () => (
              <Stack height="100%" alignItems="center" justifyContent="center">
                {t("projectitemrevision.noRows")}
              </Stack>
            ),
          }}
          localeText={{
            MuiTablePagination: {
              labelRowsPerPage: t("tableRows.rowsPerPage"),
              labelDisplayedRows: ({ from, to, count }) =>
                `${from} - ${to} ${t("tableRows.of")} ${count}`,
            },
          }}
        ></DataGrid>
      </div> */}
    </>
  );
};

export default ProjectItemRevisionHydra;
